/// <amd-module name="Build/Run/Components/JobsCard" />
import * as React from "react";

import { RunDetailsData, RunStageData } from "Build/Client/Contracts/DataProvider";

import { JobsTable } from "Build/Run/Components/JobsTable";
import { StageGraph } from "Build/Run/Components/StageGraph";
import * as Resources from "Build/Run/Resources";

import { IRunDetailsService } from "Build/Run/RunDetailsService.types";

import { ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { ScreenContext, ScreenSize } from "VSS/Core/Util/Screen";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

import { Card } from "VSSUI/Card";
import { TitleSize } from "VSSUI/Header";
import { Observer } from "VSSUI/Observer";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { Tab, TabBar, TabContent, TabProvider, TabSize } from "VSSUI/Tabs";
import { css } from "VSSUI/Util";
import { ScreenSizeObserver } from "VSSUI/Utilities/ScreenSize";

namespace Tabs {
    export const Jobs = "jobs";
    export const Stages = "stages";
}

export interface IJobsCardProps extends IVssComponentProperties {
    onReviewStageClicked: (stage: RunStageData) => void;
    onReviewManualValidationClicked: (stage: RunStageData) => void;
}

export class JobsCard extends VssComponent<IJobsCardProps, {}> {
    private _run: RunDetailsData;
    private _selectedTabId: ObservableValue<string>;
    private _tabExplicitlyChanged = false;

    constructor(props: IJobsCardProps, context: IVssComponentContext) {
        super(props, context);

        const service = this.context.pageContext.getService<IRunDetailsService>("IRunDetailsService");
        this._run = service.data.value;
        this._selectedTabId = new ObservableValue(Tabs.Stages);
    }

    public render() {
        const run = this._run;
        if (run.stages.length === 0 && run.jobs.length === 0) {
            return null;
        }
        else if (run.stages.length === 1) {
            return (
                <Card className="flex-grow bolt-table-card margin-top-16" contentProps={{ contentPadding: false }} titleProps={{ text: Resources.JobsTitle, size: TitleSize.Medium }}>
                    <JobsTable onReviewStageClicked={this.props.onReviewStageClicked} onReviewManualValidationClicked={this.props.onReviewManualValidationClicked}/>
                </Card>
            );
        }
        else {
            return (
                <Card className="flex-grow bolt-table-card margin-top-16" contentProps={{ contentPadding: false }}>
                    <Surface background={SurfaceBackground.normal}>
                        <Observer selectedTab={this._selectedTabId}>
                            {(props: {selectedTab: string})=> (
                                <ScreenSizeObserver>
                                    {(screenProps: { screenSize: ScreenSize}) => {
                                        // Make the default tab jobs for mobile, otherwise, stages is the default
                                        const selectedTabId = this._tabExplicitlyChanged ? props.selectedTab : (screenProps.screenSize === ScreenSize.xsmall ? Tabs.Jobs : Tabs.Stages);
                                        return (
                                            <div className={css("jobs-card-page flex-column", selectedTabId === Tabs.Stages ? "h-scroll-auto" : "h-scroll-hidden")}>
                                                <TabProvider selectedTabId={selectedTabId} providers={new ObservableArray([])}>
                                                    <TabBar onSelectedTabChanged={this._onTabChanged} disableSticky={true} tabSize={TabSize.LargeLink}>
                                                        <Tab id={Tabs.Stages} key={Tabs.Stages} name={Resources.StagesTitle} />
                                                        <Tab id={Tabs.Jobs} key={Tabs.Jobs} name={Resources.JobsTitle} />
                                                    </TabBar>
                                                    <div className="jobs-card-content margin-top-16">
                                                        <TabContent>
                                                            {
                                                                selectedTabId === Tabs.Jobs &&
                                                                <JobsTable onReviewStageClicked={this.props.onReviewStageClicked} onReviewManualValidationClicked={this.props.onReviewManualValidationClicked} />
                                                            }
                                                            {
                                                                selectedTabId === Tabs.Stages &&
                                                                <StageGraph onReviewStageClicked={this.props.onReviewStageClicked} onReviewManualValidationClicked={this.props.onReviewManualValidationClicked}/>
                                                            }
                                                        </TabContent>
                                                    </div>
                                                </TabProvider>
                                            </div>
                                        );
                                    }}
                                </ScreenSizeObserver>
                            )}
                        </Observer>
                    </Surface>
                </Card>
            );
        }
    }

    private _onTabChanged = (tabKey: string) => {
        this._tabExplicitlyChanged = true;
        this._selectedTabId.value = tabKey;
    }
}